import API from 'aurora-api';
import * as urls from 'aurora-api/urls';

const api = new API();

class PropertiesService {
  static fetchProperty = (propertyId, params) => api.get(urls.PROPERTY.PROPERTY, propertyId, params);

  static fetchPropertyLease = propertyId => api.get(urls.PROPERTY_SERVICE.LEASE_PROPERTY, propertyId);

  static fetchOwnershipProperties = data => api.post(urls.PROPERTY_SERVICE.OWNERSHIP_PROPERTIES, data);

  static fetchLeaseProperties = data => api.post(urls.PROPERTY_SERVICE.LEASE_PROPERTIES, data);

  static fetchMortgageProperties = data => api.post(urls.PROPERTY_SERVICE.MORTGAGE_PROPERTIES, data);

  static fetchLeasePropertiesPMA = (data, id) => api.post(urls.PROPERTY_SERVICE.LEASE_PROPERTIES_PMA, data, null, id);

  static fetchPropertyProjects = query => api.get(urls.PROPERTY.PROJECTS, null, query);

  static fetchPropertyProfessions = query => api.get(urls.PROPERTY.PROFESSIONS, null, query);

  static fetchPropertyProjectById = id => api.get(urls.PROPERTY.PROJECT_BY_ID, id);

  static fetchPropertyProfessionById = id => api.get(urls.PROPERTY.PROFESSION_BY_ID, id);

  static fetchPropertyProfessionByLicenseNumber = data =>
    api.get(urls.PROPERTY.PROFESSION_BY_LICENSE_NUMBER, null, data);

  static fetchBuildingWithoutPage = id => api.get(urls.PROPERTY.UNITS_BY_BUILDING_ID, id);

  static fetchProjectByProgressReport = id => api.get(urls.PROPERTY.PROJECT_BY_PROGRESS_REPORT, id);

  static fetchProjectByServiceChargesGroups = id => api.get(`${urls.PROPERTY.PROJECT_BY_SERVICE_CHARGES}/${id}/group`);

  static fetchProjectByServiceChargesGroupData = (id, groupId) =>
    api.get(`${urls.PROPERTY.PROJECT_BY_SERVICE_CHARGES}/${id}/group/${groupId}`);
}

export default PropertiesService;
